import { debounce } from '../functions.js';

document.addEventListener('DOMContentLoaded', () => {
    const $documentElement = document.documentElement;

    const searchConfigs = [
        {
            toggleSelector: '.navbar-search-toggle',
            formSelector: '#search-form',
            bodyClass: 'has-search-open',
            closeOnScroll: true,
        },
        {
            toggleSelector: '.page-home__bar-search__toggle',
            formSelector: '#search-form-home',
            bodyClass: '',
            closeOnScroll: false,
        }
    ];

    searchConfigs.forEach(({ toggleSelector, formSelector, bodyClass, closeOnScroll }) => {
        const $toggles = document.querySelectorAll(toggleSelector);
        const $form = document.querySelector(formSelector);

        if (!$toggles.length || !$form) return;

        const closeSearchForm = () => {
            $form.classList.remove('is-active');
            if (bodyClass) $documentElement.classList.remove(bodyClass);
            $toggles.forEach(($toggle) => $toggle.classList.remove('is-active'));
        };

        $toggles.forEach(($toggle) => {
            $toggle.addEventListener('click', () => {
                $form.classList.toggle('is-active');
                if (bodyClass) $documentElement.classList.toggle(bodyClass);

                if ($form.classList.contains('is-active')) {
                    const input = $form.querySelector('input');
                    if (input) input.focus();
                    $toggle.classList.add('is-active');
                } else {
                    $toggle.classList.remove('is-active');
                }
            });
        });

        document.addEventListener('click', (event) => {
            if (!$form.contains(event.target) && !Array.from($toggles).some(el => el.contains(event.target))) {
                closeSearchForm();
            }
        });

        if (closeOnScroll) {
            const debouncedHandleScroll = debounce(closeSearchForm, 100);

            document.addEventListener('scroll', debouncedHandleScroll);
        }
    });
});
